import { render, staticRenderFns } from "./TabsAndControls.vue?vue&type=template&id=4bfd3a10&"
import script from "./TabsAndControls.vue?vue&type=script&lang=ts&"
export * from "./TabsAndControls.vue?vue&type=script&lang=ts&"
import style0 from "./TabsAndControls.vue?vue&type=style&index=0&id=4bfd3a10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports